import { render, staticRenderFns } from "./AppSumoPage.vue?vue&type=template&id=d4c21b16"
import script from "./AppSumoPage.vue?vue&type=script&lang=js"
export * from "./AppSumoPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports